<div class="cd-modal-backdrop" (click)="close.emit()">
  <div class="cd-modal-wrap">
    <!-- Modal Head -->
    <div class="modal-head">
      <div>
        <div class="eyebrow">DETAIL VIEW</div>
        <h2>Readiness Profile</h2>
      </div>
      <button type="button" class="icon-button" (click)="close.emit()" aria-label="Close modal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Student Info -->
    <div class="drawer-profile">
      <div class="avatar large">{{ initials }}</div>
      <div>
        <h3>{{ student.name }}</h3>
        <p>{{ student.department }} • {{ student.year }}</p>
      </div>
    </div>

    <!-- Score & Classification Grid -->
    <div class="detail-grid">
      <div class="grid-card">
        <span>Readiness Score</span>
        <strong [ngClass]="scoreClass" class="score-number">{{ student.score }}</strong>
      </div>
      <div class="grid-card">
        <span>Classification</span>
        <strong [ngClass]="scoreClass" class="classification-text">{{ classification }}</strong>
      </div>
    </div>

    <!-- AI Diagnostic Cards -->
    <div class="insights-list">
      <div class="insight-card strength">
        <strong>Strengths</strong>
        <p>{{ strengthText }}</p>
      </div>
      <div class="insight-card weakness">
        <strong>Areas Needing Attention</strong>
        <p>{{ weaknessText }}</p>
      </div>
      <div class="insight-card action">
        <strong>Recommended Action</strong>
        <p>{{ actionText }}</p>
      </div>
    </div>
  </div>
</div>
